export default {
    methods: {
        getFirstItem(items) {

            return items ? items[0] : '';
        },
    }
}